import * as React from "react";
// import Button from '@mui/material/Button';
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
// import CloseIcon from '@mui/icons-material/Close';
import Slide from "@mui/material/Slide";
import translate from "../../services/translation/lang";
import Currency from "../Currency";
import { customizationParser, getCurrencyNumberOfDigits } from "../../services/helpers/customization-helper";
import { truncateToDecimals } from "../../services/helpers/number-formatter";
// import GrpAutoplay from "../game-rules-preview/GrpAutoplay";
import GrpGameMenu from "../game-rules-preview/GrpGameMenu";
import GrpBetHistory from "../game-rules-preview/GrpBetHistory";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// const MAX_AUTOPLAY_ROUNDS = 100;

export default function GameRulesModal({
  open,
  handleClose,
  maxMultiplier,
  maxPayOut,
  currency,
  ticketTimeountS,
  maxBet,
  minBet,
  jackpot,
  rtp,
  jpContribution,
}) {
  const customization = customizationParser();
  const turboIcon = "img/turbo_idle.png";

  //console.log("customization", customization)
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      className="game-rules-modal"
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            {translate("detailed_game_rules")}
          </Typography>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <div className="close-icon"></div>
          </IconButton>
        </Toolbar>
      </AppBar>
      <div className="game-rules-modal-wrapper">
        <h5>{translate("game_rules")}</h5>
        <p>{translate("game_rules_p1")}</p>
        <p>{translate("game_rules_p2")}</p>
        <p>{translate("game_rules_p3")}</p>
        <p className="mb-5">{translate("game_rules_p4")}</p>

        <h5>{translate("general")}</h5>
        <ul>
          <li>
            <p>{translate("general_p1")}</p>
          </li>
          <li>
            <p className="mb-0">{translate("general_p2")}</p>
          </li>
        </ul>
        <p className="mb-5">{translate("general_p3")}</p>

        <h5>{translate("betting")}</h5>
        <ul className="mb-5">
          <li>
            <p>{translate("betting_p1")}</p>
          </li>
          <li>
            <p>{translate("betting_p2")}</p>
          </li>
          <li>
            <p>{translate("betting_p3")}</p>
          </li>
          <li>
            <p>{translate("betting_p4")}</p>
          </li>
          <li>
            <p>{translate("betting_p5")}</p>
          </li>
          <li>
            <p>{translate("betting_p6")}</p>
          </li>
          <li>
            <p>{translate("betting_p7")}</p>
          </li>
          <li>
            <p className="mb-0">{translate("betting_p8")}</p>
          </li>
        </ul>

        <h5>{translate("game_menu")}</h5>
        <ul className="mb-5">
          <li>
            <p>{translate("game_menu_p1")}</p>
          </li>
          <li>
            <p>{translate("game_menu_p2")}</p>
          </li>
          <li>
            <p>{translate("game_menu_p3")}</p>
          </li>
          <li>
            <p>{translate("game_menu_p4")}</p>
          </li>
          <li>
            <p className="mb-0">{translate("game_menu_p5")}</p>
          </li>
        </ul>
        <GrpGameMenu />
        <p className="game-rules-label">{translate("game_menu_ss")}</p>
        <p className="mb-5">{translate("game_menu_p6")}</p>

        <GrpBetHistory />
        <p className="game-rules-label">{translate("bet_history")}</p>

        <p>{translate("autoplay_p1")}</p>
        <h5>{translate("autoplay")}</h5>
        <ul className="mb-5">
          <li>
            <p>{translate("autoplay_p2")}</p>
          </li>
          <li>
            <p>{translate("autoplay_p3")}</p>
          </li>
          <li>
            <p>{translate("autoplay_p4")}</p>
          </li>
          <li>
            <p>{translate("autoplay_p5")}</p>
          </li>
          <li>
            <p>{translate("autoplay_p6")}</p>
          </li>
          <li>
            <p className="mb-0">{translate("game_menu_p5")}</p>
          </li>
        </ul>

        <div className="gr-turbo-title-holder">
          <h5>{translate("turbo_mode")}</h5>
          <img src={turboIcon} alt="turbo mode" className="gr-turbo-icon"/>
        </div>
        <ul className="mb-5">
          <li>
            <p>{translate("turbo_mode_p1")}</p>
          </li>
          <li>
            <p>{translate("turbo_mode_p2")}</p>
          </li>
        </ul>

        <h5>{translate("turbo_balance")}</h5>
        <ul className="mb-5">
          <li>
            <p>{translate("turbo_balance_p1")}</p>
          </li>
          <li>
            <p>{translate("turbo_balance_p2")}</p>
          </li>
          <li>
            <p>{translate("turbo_balance_p3")}</p>
          </li>
          <li>
            <p className="mb-0">{translate("turbo_balance_p4")}</p>
          </li>
        </ul>

        {/* <h5>{translate("free_bets")}</h5>
        <ul className="mb-5">
          <li>
            <p className="mb-0">{translate("free_bets_p1")}</p>
          </li>
        </ul> */}

        <h5>{translate("fairness")}</h5>
        <ul className="mb-5">
          <li>
            <p>{translate("fairness_p1")}</p>
          </li>
          <li>
            <p className="mb-0">{translate("fairness_p2")}</p>
          </li>
        </ul>

        {customization?.hideRTP ? null : <h5>{translate("return_to_player")}</h5>}
        {customization?.hideRTP ? null : <ul className="mb-5">
          <li>
            <p className="mb-0">
              {translate("return_to_player_p1")}
              {rtp}%.
            </p>
          </li>
        </ul>}

        <h5>{translate("disconection_and_error")}</h5>
        <ul className="mb-5">
          <li>
            <p>{translate("disconection_and_error_p1")}</p>
          </li>
          <li>
            <p className="mb-0">{translate("disconection_and_error_p2")}</p>
          </li>
        </ul>

        <h5>{translate("other")}</h5>
        <ul className="mb-5">
          <li>
            <p>
              {translate("min_bet_is")}{" "}
              {new Intl.NumberFormat("en-US", {
                minimumFractionDigits: getCurrencyNumberOfDigits() ?? 2,
                maximumFractionDigits: getCurrencyNumberOfDigits() ?? 2,
              }).format(
                truncateToDecimals(minBet, getCurrencyNumberOfDigits() ?? 2)
              )}{" "}
              <Currency>{currency}</Currency>.
            </p>
          </li>
          <li>
            <p>
              {translate("max_bet_is")}{" "}
              {new Intl.NumberFormat("en-US", {
                minimumFractionDigits: getCurrencyNumberOfDigits() ?? 2,
                maximumFractionDigits: getCurrencyNumberOfDigits() ?? 2,
              }).format(
                truncateToDecimals(maxBet, getCurrencyNumberOfDigits() ?? 2)
              )}{" "}
              <Currency>{currency}</Currency>.
            </p>
          </li>
          <li>
            <p>
              {translate("max_payout")}{" "}
              {new Intl.NumberFormat("en-US", {
                minimumFractionDigits: getCurrencyNumberOfDigits() ?? 2,
                maximumFractionDigits: getCurrencyNumberOfDigits() ?? 2,
              }).format(
                truncateToDecimals(maxPayOut, getCurrencyNumberOfDigits() ?? 2)
              )}{" "}
              <Currency>{currency}</Currency> {translate("per_bet")}
            </p>
          </li>
          <li>
            <p>{translate("other_p1")}</p>
          </li>
          <li>
            <p className="mb-0">{translate("other_p2")}</p>
          </li>
        </ul>
      </div>
    </Dialog>
  );
}
